import Select from "react-select";

function BusinessServiceSection({

  ReligionOptions,
  casteOptions,
  communiteOptions,
  langOptions,

  selectedReligion,
  setSelectedReligion,

  selectedCaste,
  setSelectedCaste,

  selectedCommunities,
  setSelectedCommunities,

  selectedLanuages,
  setSelectedLanguages,

  CheckboxOption,
  cleanSelectStyles,

}) {

  return (
    <div className="Business-container mt-4">

      <h2 className="mt-2">
         Service Details
      </h2>

      <div className="field">

        <label>
          Religions you serve *
        </label>

        <Select
          options={ReligionOptions}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option: CheckboxOption,
          }}
          styles={cleanSelectStyles}
          placeholder="Select Religions"
          value={
            selectedReligion.includes("all")
              ? [
                  {
                    value: "all",
                    label: "All Religions",
                  },
                ]
              : ReligionOptions.filter((o) =>
                  selectedReligion.includes(
                    o.value
                  )
                )
          }
          onChange={(opts) => {

            if (!opts?.length)
              return setSelectedReligion([]);

            const values =
              opts.map((o) => o.value);

            if (
              values.includes("all") &&
              !selectedReligion.includes(
                "all"
              )
            )
              return setSelectedReligion([
                "all",
              ]);

            if (
              selectedReligion.includes(
                "all"
              )
            )
              return setSelectedReligion(
                values.filter(
                  (v) => v !== "all"
                )
              );

            setSelectedReligion(values);
          }}
        />
      </div>

      <div className="field">

        <label>
          Castes you serve  *
        </label>

        <Select
          options={casteOptions}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option: CheckboxOption,
          }}
          styles={cleanSelectStyles}
          placeholder="Select Castes"
          value={
            selectedCaste.includes("all")
              ? [
                  {
                    value: "all",
                    label: "All Castes",
                  },
                ]
              : casteOptions.filter((o) =>
                  selectedCaste.includes(
                    o.value
                  )
                )
          }
          onChange={(opts) => {

            if (!opts?.length)
              return setSelectedCaste([]);

            const values =
              opts.map((o) => o.value);

            if (
              values.includes("all") &&
              !selectedCaste.includes(
                "all"
              )
            )
              return setSelectedCaste([
                "all",
              ]);

            if (
              selectedCaste.includes(
                "all"
              )
            )
              return setSelectedCaste(
                values.filter(
                  (v) => v !== "all"
                )
              );

            setSelectedCaste(values);
          }}
        />
      </div>

      <div className="field">

        <label>
          Communities you serve  *
        </label>

        <Select
          options={communiteOptions}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option: CheckboxOption,
          }}
          styles={cleanSelectStyles}
          placeholder="Select Communities"
          value={
            selectedCommunities.includes(
              "all"
            )
              ? [
                  {
                    value: "all",
                    label:
                      "All Communities",
                  },
                ]
              : communiteOptions.filter((o) =>
                  selectedCommunities.includes(
                    o.value
                  )
                )
          }
          onChange={(opts) => {

            if (!opts?.length)
              return setSelectedCommunities([]);

            const values =
              opts.map((o) => o.value);

            if (
              values.includes("all") &&
              !selectedCommunities.includes(
                "all"
              )
            )
              return setSelectedCommunities([
                "all",
              ]);

            if (
              selectedCommunities.includes(
                "all"
              )
            )
              return setSelectedCommunities(
                values.filter(
                  (v) => v !== "all"
                )
              );

            setSelectedCommunities(values);
          }}
        />
      </div>

      <div className="field">

        <label>
          Languages you serve  *
        </label>

        <Select
          options={langOptions}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option: CheckboxOption,
          }}
          placeholder="Select Languages"
          styles={cleanSelectStyles}
          value={
            selectedLanuages.includes(
              "all"
            )
              ? [
                  {
                    value: "all",
                    label:
                      "All Languages",
                  },
                ]
              : langOptions.filter((o) =>
                  selectedLanuages.includes(
                    o.value
                  )
                )
          }
          onChange={(opts) => {

            if (!opts?.length)
              return setSelectedLanguages([]);

            const values =
              opts.map((o) => o.value);

            if (
              values.includes("all") &&
              !selectedLanuages.includes(
                "all"
              )
            )
              return setSelectedLanguages([
                "all",
              ]);

            if (
              selectedLanuages.includes(
                "all"
              )
            )
              return setSelectedLanguages(
                values.filter(
                  (v) => v !== "all"
                )
              );

            setSelectedLanguages(values);
          }}
        />
      </div>
    </div>
  );
}

export default BusinessServiceSection;